import { formatShiftTimeRange } from 'src/content/applications/quote/shiftTimePresentation';
import { useWorkerProfile, legacyProfileResponse } from 'src/workspaces/workerProfile/WorkerProfileContext';
// import { Card } from '@mui/material';
import { CryptoOrder, Contractor } from 'src/models/crypto_order';

import { parseISO } from 'date-fns';

import { Card, CircularProgress } from '@mui/material';

import ContractorCalendarTable from './contractorCalenderTable';
import React from 'react';
import { getAllUsers, getUserJobHistory } from 'src/helper/backend_helper';
import { useLocation } from 'react-router';
import { useQuery } from '@tanstack/react-query';

const colorMap = {};

const getColorById = (id) => {
  if (!colorMap[id]) {
    // Generate a pastel color for consistency and contrast
    const hue = Math.floor(Math.random() * 360);
    colorMap[id] = `hsl(${hue}, 70%, 85%)`;
  }
  return colorMap[id];
};

function ContractorCalendarData() {
  const scope = useWorkerProfile();
  const location = useLocation();
  const state: any = location.state;

  const {
    data: jobs,
    error,
    isLoading,
    isError
  }: any = useQuery(
    ['user_calendar', scope?.companyId, scope?.revision, scope?.workerId ?? state?.user?.id], // Unique key for caching
    () => scope ? legacyProfileResponse(scope.data.jobs) : getUserJobHistory(state?.user?.id), // Fetch function
    {
      select: (response) => {
        const formattedJobs = response.data.data.map((item) => ({
          id: item?.id,
          eventId: item?.shift?.Event?.id,
          eventTitle: item?.shift?.Event?.title,
          title: `${item.position} | ${formatShiftTimeRange(item, item.shift?.timezone)}`,
          // Shift dates are calendar days; midnight UTC must not move them
          // to the previous local day in the month-view calendar.
          start: parseISO(item.startDate.slice(0, 10)),
          end: parseISO(item.endDate.slice(0, 10)),
          style: {
            backgroundColor: getColorById(item?.id),
            borderRadius: '6px',
            border: 'none',
            color: '#000',
            fontWeight: 500
          }
        }));
        return formattedJobs;
      }
      // keepPreviousData: true // Keeps previous data while fetching new data
    }
  );

  return (
    // <Card>
    <>
      {isLoading && <div><CircularProgress size={15} /></div>}
      <ContractorCalendarTable jobs={jobs} />
    </>
    // </Card>
  );
}

export default ContractorCalendarData;
